import Grid from '@material-ui/core/Grid';
import AddBoxIcon from '@material-ui/icons/AddBox';
import { FiltersWorshop } from '../ListWorshop/FiltersWorshop';
import { Alert, WorkshopTypesList } from '../Tools';
import BuildIcon from '@material-ui/icons/Build';
import BottomNavigation from '@material-ui/core/BottomNavigation';
import BottomNavigationAction from '@material-ui/core/BottomNavigationAction';
import Button from '@material-ui/core/Button';
import { Loading } from '../Tools/Loading';
import EditIcon from '@material-ui/icons/Edit';
import { Refresh } from '@material-ui/icons';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import LockIcon from '@material-ui/icons/Lock';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import MenuItem from '@material-ui/core/MenuItem';
import Modal from '@material-ui/core/Modal';
import { NewWorkshopType } from './NewWorkshopType';
import Pagination from '@material-ui/lab/Pagination';
import Paper from '@material-ui/core/Paper';
import Select from '@material-ui/core/Select';
import { shouldReload } from 'utils/state.handlers';
import Snackbar from '@material-ui/core/Snackbar';
import TextField from '@material-ui/core/TextField';
import { ThemeProvider } from '@material-ui/core/styles';
import { WorkshopType } from 'types/api/responses';
import { allWorkshopTypes, updateWorkshopType } from 'redux/actions/workshopTypes.actions';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import React, { useEffect, useState } from 'react';
import { myTheme, Styles, getModalStyle, StyledTableCell, StyledTableRow } from '../Tools';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableBody from '@material-ui/core/TableBody';
import ModalCustom from 'components/Tools/ModalCustom';
import { CircularProgress } from '@mui/material';
const SIZE = 9,
  INITPAGE = 1;

function SearchDetails() {
  const classes = Styles();

  const workshopTypes = useTypedSelector((z) => z.workshopTypes);
  //const zones = useTypedSelector((z) => z.zones);
  //const office = useTypedSelector((o) => o.branchOffices);
  const dispatch = useThunkDispatch();

  const [nameSearch, setNameSearch] = React.useState(
    workshopTypes.filter.NameContains ? workshopTypes.filter.NameContains : '',
  );
  const [openStatus, setOpenStatus] = React.useState(false);
  const [theStatus, setTheStatus] = React.useState(
    workshopTypes.filter.Status != null ? workshopTypes.filter.Status : '0',
  );
  //evento de cambio en nombre a buscar
  const handleChangeNameSearch = (event: React.ChangeEvent<{ value: unknown }>) => {
    setNameSearch(event.target.value as string);
  };

  //evento de busqueda segun nombre
  const handleSearch = () => {
    //alert(nameSearch + 'F');
    dispatch(
      allWorkshopTypes(
        { page: INITPAGE, size: SIZE },
        {
          NameContains: nameSearch,
          Status: workshopTypes.filter.Status,
        },
      ),
    );
  };

  const handleResetSearch = () => {
    setNameSearch('');
    setTheStatus('0');
    dispatch(
      allWorkshopTypes(
        { page: INITPAGE, size: SIZE },
        {
          NameContains: null,
          Status: null,
        },
      ),
    );
  };

  const handleOpenStatus = () => {
    setOpenStatus(true);
  };

  const handleClosedStatus = () => {
    setOpenStatus(false);
  };

  const handleChangeStatus = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;
    setTheStatus(value);
    dispatch(
      allWorkshopTypes(
        { page: INITPAGE, size: SIZE },
        {
          NameContains: workshopTypes.filter.NameContains,
          Status: value === '0' ? null : value,
        },
      ),
    );
  };

  return (
    <form className={classes.rootForm} noValidate autoComplete="off">
      {workshopTypes.isLoading ? (
        <div>
          <CircularProgress />
        </div>
      ) : (
        <div style={{ display: 'inline-flex', alignItems: 'center', marginRight: '10px' }}>
          <TextField
            id="outlined-read-only-input"
            label="Tipo Taller"
            value={nameSearch}
            inputProps={{ maxLength: 50 }}
            onChange={handleChangeNameSearch}
            onKeyPress={(ev) => {
              if (ev.key === 'Enter') {
                ev.preventDefault();
                handleSearch();
              }
            }}
            variant="outlined"
            required
          />
          <FormControl style={{ marginRight: '10px' }}>
            <InputLabel id="state-id-label">Estado</InputLabel>
            <Select
              labelId="select-filter-rol"
              id="filter-controlled-open-select-rol"
              value={theStatus}
              onChange={handleChangeStatus}
            >
              <MenuItem value={'0'}>Todos</MenuItem>
              <MenuItem value={'Disabled'}>Inactivos</MenuItem>
              <MenuItem value={'Active'}>Activos</MenuItem>
            </Select>
          </FormControl>
          <Button
            variant="outlined"
            onClick={handleResetSearch}
            className={classes.submit}
            style={{ color: '#343c89', marginLeft: '15px' }}
            startIcon={<Refresh />}
          >
            Refrescar
          </Button>
        </div>
      )}
    </form>
  );
}

function ListWorkshopType() {
  const classes = Styles();
  const workshopTypes = useTypedSelector((u) => u.workshopTypes);
  const [messageSnack, setMessageSnack] = React.useState<string | null>(null);

  //modal
  const [modalStyle] = React.useState(getModalStyle(40, 20));
  const [page, setPage] = React.useState(1);
  const [openModal, setOpenModal] = React.useState({
    open: false,
    loading: false,
  });
  const [modalActive, setmodalActive] = useState(false);
  const [theWorkshopType, setTheWorkshopType] = useState({
    id: 0,
    name: '',
    active: false,
    external: false,
  });
  const [isNew, setIsNew] = React.useState(true);
  const dispatch = useThunkDispatch();

  useEffect(() => {
    if (shouldReload(workshopTypes)) {
      dispatch(
        allWorkshopTypes({ size: SIZE, page: page }, { NameContains: null, Status: null }),
      );
    }
  }, [workshopTypes]);

  const handleOpenModal = () => {
    setOpenModal({
      open: true,
      loading: false,
    });
    setmodalActive(false);
  };

  const handleChangePage = (event: React.ChangeEvent<unknown>, newPage: number) => {
    dispatch(allWorkshopTypes({ size: SIZE, page: newPage }, workshopTypes.filter));
    setPage(newPage);
  };

  const updateList = () => {
    dispatch(allWorkshopTypes({ size: SIZE, page: page }, workshopTypes.filter));
  };

  const handleCloseModal = (loading: boolean | null, flag: boolean) => {
    if (loading === null && !openModal.loading) {
      setOpenModal({
        open: false,
        loading: openModal.loading,
      });
    } else if (loading) {
      setOpenModal({
        open: openModal.open,
        loading: loading,
      });
    } else if (loading === false) {
      setOpenModal({
        open: false,
        loading: loading,
      });
    }
    if (flag) {
      setmodalActive(true);
    }
  };

  const handleDesactive = ({ active, item }: { active: boolean; item: WorkshopType }) => {
    setMessageSnack(
      active
        ? 'El tipo de taller se activó con éxito.'
        : 'El tipo de taller se desactivó con éxito.',
    );
    setmodalActive(false);
    setmodalActive(true);
    dispatch(
      updateWorkshopType({
        id: item.id,
        name: item.name,
        active: active,
        external: item.external,
      }),
    );
  };

  const handleChangeModal = ({
    provider,
    flag,
  }: {
    provider: WorkshopType;
    flag: boolean;
  }) => {
    setMessageSnack(null);
    setTheWorkshopType(provider);
    setIsNew(flag);
    handleOpenModal();
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setmodalActive(false);
  };

  return (
    <ThemeProvider theme={myTheme}>
      <ModalCustom
        className={classes.paperModalNewProvider}
        open={openModal.open}
        onClose={() => {
          handleCloseModal(null, false);
        }}
      >
        <NewWorkshopType
          workshopType={theWorkshopType}
          isNew={isNew}
          handleClose={handleCloseModal}
          updateList={updateList}
        />
      </ModalCustom>
      <Snackbar open={modalActive} autoHideDuration={15000} onClose={handleClose}>
        {workshopTypes.isLoading ? (
          <Alert onClose={handleClose} severity="info">
            <div>Editando Tipo de Taller...</div>
          </Alert>
        ) : (
          <div>
            {workshopTypes.error ? (
              <Alert onClose={handleClose} severity="error">
                <div>ocurrio un error {workshopTypes.error.message}</div>
              </Alert>
            ) : (
              <Alert onClose={handleClose} severity="success">
                <div>
                  {messageSnack ? messageSnack : ' Se edito con exito el Tipo de Taller.'}
                </div>
              </Alert>
            )}
          </div>
        )}
      </Snackbar>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        marginBottom: '24px',
        marginTop: '16px'
      }}>
        <BuildIcon style={{ fontSize: '40px', color: '#343c89' }} />
        <div style={{ fontSize: '2rem', color: '#343c89', fontWeight: 700 }}>
          Tipos de Taller
        </div>
      </div>
      <div className={classes.divider}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Grid item xs={11} style={{ width: '100%' }}>
            <Paper 
              className={`${classes.paper} ${classes.flexWrap}`}
              elevation={3}
              style={{
                borderRadius: '12px',
                padding: '16px 24px',
                marginBottom: '16px'
              }}
            >
              <div className={classes.flexWrap}>
                <SearchDetails />
                <BottomNavigation
                  showLabels
                  onClick={() => {
                    handleChangeModal({
                      provider: {
                        id: 0,
                        name: '',
                        active: true,
                        external: true,
                      },
                      flag: true,
                    });
                  }}
                  style={{
                    backgroundColor: 'transparent',
                    transition: 'all 0.3s ease'
                  }}
                >
                  <BottomNavigationAction
                    label="Agregar Registro"
                    icon={<AddBoxIcon />}
                    style={{ 
                      color: '#0e814b',
                      transition: 'all 0.3s ease'
                    }}
                  />
                </BottomNavigation>
              </div>
            </Paper>
          </Grid>
          <Grid item xs={11} style={{ width: '100%', marginTop: '0.1em' }}>
            <Paper elevation={3} style={{ borderRadius: '12px', overflow: 'hidden' }}>
              <TableContainer style={{ maxHeight: '75vh' }}>
                <Table className={classes.table} stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Descripción Tipo de Taller</StyledTableCell>
                    <StyledTableCell align="center">Estado</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {workshopTypes.workshopTypes.workshopTypes.map((item) => {
                    return (
                      <StyledTableRow key={item.id}>
                        <StyledTableCell component="th" scope="row">
                          {item.name}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <div className={classes.flexRowCenter}>
                            <BottomNavigation
                              showLabels
                              onClick={() => {
                                handleChangeModal({ provider: item, flag: false });
                              }}
                              className={classes.buttons}
                              style={{ backgroundColor: 'transparent' }}
                            >
                              <BottomNavigationAction
                                label="Editar"
                                icon={<EditIcon />}
                                style={{ 
                                  color: '#343c89', 
                                  margin: '0px',
                                  cursor: 'pointer',
                                  borderRadius: '8px',
                                  transition: 'all 0.3s ease'
                                }}
                                onMouseEnter={(e) => {
                                  e.currentTarget.style.backgroundColor = 'rgba(52, 60, 137, 0.1)';
                                  e.currentTarget.style.transform = 'scale(1.05)';
                                }}
                                onMouseLeave={(e) => {
                                  e.currentTarget.style.backgroundColor = 'transparent';
                                  e.currentTarget.style.transform = 'scale(1)';
                                }}
                              />
                            </BottomNavigation>
                            {workshopTypes.isLoading ? (
                              <div>
                                <CircularProgress />
                              </div>
                            ) : (
                              <div>
                                {item.active ? (
                                  <BottomNavigation showLabels className={classes.buttons} style={{ backgroundColor: 'transparent' }}>
                                    <BottomNavigationAction
                                      label="desactivar"
                                      onClick={() => {
                                        handleDesactive({ active: false, item: item });
                                      }}
                                      icon={<LockIcon />}
                                      style={{ 
                                        color: '#dc3545',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        transition: 'all 0.3s ease'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(220, 53, 69, 0.1)';
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    />
                                  </BottomNavigation>
                                ) : (
                                  <BottomNavigation showLabels className={classes.buttons} style={{ backgroundColor: 'transparent' }}>
                                    <BottomNavigationAction
                                      label="activar"
                                      onClick={() => {
                                        handleDesactive({ active: true, item: item });
                                      }}
                                      icon={<LockOpenIcon />}
                                      style={{ 
                                        color: '#0e814b',
                                        cursor: 'pointer',
                                        borderRadius: '8px',
                                        transition: 'all 0.3s ease'
                                      }}
                                      onMouseEnter={(e) => {
                                        e.currentTarget.style.backgroundColor = 'rgba(14, 129, 75, 0.1)';
                                        e.currentTarget.style.transform = 'scale(1.05)';
                                      }}
                                      onMouseLeave={(e) => {
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                        e.currentTarget.style.transform = 'scale(1)';
                                      }}
                                    />
                                  </BottomNavigation>
                                )}
                              </div>
                            )}
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
            </Paper>
          </Grid>
          <div style={{ 
            display: 'flex', 
            justifyContent: 'center',
            marginTop: '16px'
          }}>
            {workshopTypes.isLoading ? (
              <Loading 
                message="Cargando datos..." 
                subMessage="Por favor espere mientras se cargan los datos" 
              />
            ) : (
              <div style={{
                backgroundColor: 'white',
                padding: '12px',
                borderRadius: '12px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
              }}>
                <Pagination
                  count={workshopTypes.workshopTypes.meta?.pages}
                  variant="outlined"
                  shape="rounded"
                  page={page}
                  onChange={handleChangePage}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}

export { ListWorkshopType };
